const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function startCheckout(lookupKey) {
    try {
        const res = await fetch(`${API}/payments/checkout`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                lookup_key: lookupKey,
                origin_url: window.location.origin,
            }),
        });
        const data = await res.json();
        if (data.checkout_url) {
            window.location.href = data.checkout_url;
        }
    } catch (e) {
        console.error("checkout failed", e);
    }
}
